import Backbone from 'backbone'
import template from './loading-page.hbs'
import loadingDots from 'scoreboard/components/loading-dots.hbs'
import ScanningIcon from 'scoreboard/components/scanning-icon'
import DatasetBuilding from 'scoreboard/datasets/not-available/dataset-building'
import Dataset from 'scoreboard/datasets/model/dataset'

var LoadingPageView = Backbone.View.extend({
	className: 'admin table-hack display-layout admin-test-view admin-test-loading',

	render: function () {
		// Setup loding dots
		this.$el.html(template())
		this.$('.panel.loading-dots-panel .panel-content').append(loadingDots())

		// Setup dataset scanning animation
		var scanningIcon = new ScanningIcon()
		this.$('.panel.dataset-scanning .dataset-scanning-wrapper').append(scanningIcon.el)
		scanningIcon.render()
		scanningIcon.init()

		// Setup dataset loading animation
		var datasetLoader = new DatasetBuilding()
		,	displayProgress = (progress) => {
				this.$('.panel.dataset-loader p.progress').html(Math.round(progress * 100) + '%')
			}

		datasetLoader.model = {
			get: () => {
				return 'ERROR MESSAGE'
			}
		}

		this.$('.panel.dataset-loader .panel-content').append(datasetLoader.el)
		datasetLoader.render()
		datasetLoader.init()
		this.progress = .1

		setTimeout(() => datasetLoader.setProgress(this.progress), 3000)

		displayProgress(this.progress)

		this.$('#dataset-building-decrement').on('click', () => {
			datasetLoader.setProgress(this.progress - .1)
			this.progress -= .1
			displayProgress(this.progress)
		})
		this.$('#dataset-building-increment').on('click', () => {
			datasetLoader.setProgress(this.progress + .1)
			this.progress += .1
			displayProgress(this.progress)
		})
		this.$('#dataset-building-complete').on('click', () => {
			datasetLoader.setProgress(1)
			this.progress = 1
			displayProgress(this.progress)
		})
		this.$('#dataset-building-reset').on('click', () => {
			datasetLoader.setProgress(0)
			this.progress = 0
			displayProgress(this.progress)
		})
		this.$('#dataset-building-stale').on('click', () => {
			datasetLoader.setState(Dataset.STALE)
			this.progress = 0
			displayProgress(this.progress)
		})
		this.$('#dataset-building-ready').on('click', () => {
			datasetLoader.setState(Dataset.READY)
			this.progress = 0
			displayProgress(this.progress)
		})
		this.$('#dataset-building-error').on('click', () => {
			datasetLoader.setState(Dataset.ERROR)
			this.progress = 0
			displayProgress(this.progress)
		})
		return this
	}
})

export default LoadingPageView
